export default __webpack_public_path__ + "static/deciduous-bb2af9504bd373f4a786d3767adee084.png";